<template>
    <div class="head-title">
        <div class="left">
            <ul class="breadcrumb">
                <li>
                    <a href="/HomeProperty" class="active">{{ $t("Property") }}</a>
                </li>
                <li>-</li>
                <li>
                    <a class="active">{{ $t("Statement") }} {{ $t("due") }} {{ $t("Rentals") }}</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="main">
        <div class="head">
            <div class="head1">
                <div class="filter-group">
                    <label for="realty-select">{{ $t("realty") }}</label>
                    <v-select id="realty-select" :options="accounts" label="name" v-model="item" class="filter-select"
                        aria-label="Select Realty">
                        <template #option="option">
                            <div class="select-option">
                                <span>{{ option.name }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="filter-group renter-group">
                    <label for="renter-select">{{ $t("renter") }}</label>
                    <v-select id="renter-select" :options="renters" label="name" v-model="selectedRenter"
                        class="filter-select renter-select" aria-label="Select Renter">
                        <template #option="option">
                            <div class="select-option">
                                <span>{{ option.name }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="filter-group">
                    <label for="status-select">{{ $t("status") }}</label>
                    <v-select id="status-select" :options="statuses" label="name" v-model="selectedStatus"
                        class="filter-select" aria-label="Select Status">
                        <template #option="option">
                            <div class="select-option">
                                <span>{{ option.name }}</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div class="filter-group">
                    <label for="from-date">{{ $t("from") }}</label>
                    <input id="from-date" type="date" :placeholder="$t('from')" v-model="from" class="filter-input"
                        aria-label="From Date" />
                    <label for="to-date">{{ $t("to") }}</label>
                    <input id="to-date" type="date" :placeholder="$t('to')" v-model="to" class="filter-input"
                        aria-label="To Date" />
                </div>
                <div class="filter-group">

                </div>
                <button type="submit" @click="submit" class="filter-button search-button" aria-label="Search">
                    <i class="bi bi-search"></i> {{ $t("search") }}
                </button>
                <button type="submit" @click="getallpayments" class="filter-button search-button" aria-label="Search"
                    v-if="data1.length > 0">
                    تاكيد السداد
                </button>
                <button type="submit" @click="exportToExcel" class="filter-button excel-button"
                    aria-label="Export to Excel">
                    <i class="bi bi-file-earmark-excel"></i> Excel
                </button>
            </div>
            <div class="head2">

            </div>
        </div>

        <div class="body" v-if="this.data1.length == 0">
            <br />
            برجاء اختيار اسم العقار
        </div>
        <div class="body" v-if="this.data1.length > 0">
            <br />
            <div style="padding: 2%; direction: rtl; font-size: small">
                <h4>
                    {{ $t("Statement") }} {{ $t("due") }} {{ $t("Rentals") }} -
                    <span>{{ realty }}</span>
                </h4>
                <h6>{{ $t("from") }} : {{ fromdate }} {{ $t("to") }} : {{ todate }}</h6>

                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $t("number") }} {{ $t("contract") }}</th>
                            <th>{{ $t("name") }} {{ $t("realty") }}</th>
                            <th>{{ $t("date") }} {{ $t("due") }}</th>
                            <th>{{ $t("date") }} {{ $t("start") }} {{ $t("contract") }}</th>
                            <th>{{ $t("date") }} {{ $t("end") }} {{ $t("contract") }}</th>
                            <th>{{ $t("number") }} {{ $t("unit") }}</th>
                            <th>{{ $t("name") }} {{ $t("renter") }}</th>
                            <th>{{ $t("amount") }} {{ $t("due") }}</th>
                            
                            <th>المتبقى من السداد</th>
                            <th>احمالى المستحق</th>
                            <th>المتبقى من العمولات</th>
                            <th>{{ $t("print") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="i in data1" :key="i">
                            <td>
                                <router-link to="">{{ i.conid }}</router-link>
                            </td>
                            <td>{{ i.propertyname }}</td>
                            <td>{{ i.duedate }}</td>
                            <td>{{ i.contstart }}</td>
                            <td>{{ i.contend }}</td>
                            <td>{{ i.unite }}</td>
                            <td>{{ i.rentername }}</td>
                            <td>{{ i.dueamount }}</td>
                            
                            <td> {{ i.paid }}</td>
                            <td>{{ i.totalchange }}</td>
                            <td>{{ i.paidcom }}</td>
                            <td>
                                <button class="filter-button" type="button" data-bs-toggle="modal"
                                    :data-bs-target="'#exampleModal' + i.conid"
                                    @click="getinstallment(i.conid, i.duedate, i, i.dueamount)">
                                    <i class="bi bi-printer-fill"></i>
                                </button>
                                <div class="modal fade" :id="'exampleModal' + i.conid" tabindex="-1"
                                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-xl">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="exampleModalLabel">
                                                    خطاب مطالبة
                                                </h5>
                                            </div>
                                            <div class="modal-body" style="padding: 2%" id="main">
                                                <div style="direction: rtl">
                                                    <div class="modhead">

                                                        <div class="part">
                                                            الصادر : {{ id }} <br />
                                                            السادة : {{ rentername }}
                                                        </div>
                                                        <div class="logo"></div>
                                                    </div>
                                                    <div style="padding: 2%">
                                                        السلام عليكم ورحمة الله وبركاتة <br />
                                                        تحية طيبة وبعد ,,,, <br />
                                                        الموضوع : مطالبة مالية <br />
                                                        إشارة الى العقد رقم {{ igarnumber }} المبرم معكم
                                                        لايجار وحدة رقم
                                                        {{ unite }}
                                                        {{ propertyname }} <br />
                                                        علية نفيدكم بالمستحق كما هو موضح بالجدول التالى
                                                    </div>
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th>م</th>
                                                                <th>النوع</th>
                                                                <th>تاريخ الاستحقاق</th>
                                                                <th>المبلغ</th>
                                                                <th>الضريبة</th>
                                                                <th>مستحق</th>
                                                                <th>محصل</th>
                                                                <th>مطلوب</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(y, id) in allinstallment" :key="y">
                                                                <td>{{ id + 1 }}</td>
                                                                <td> <a @click.prevent="removeinstall(id)">{{ $t(y.duetype)
                                                                        }}</a></td>
                                                                <td>
                                                                    {{
                                                                        " الفترة من" +
                                                                        " " +
                                                                        y.from +
                                                                        " " +
                                                                        "الى " +
                                                                        y.to
                                                                    }}
                                                                </td>
                                                                <td><span>{{ Number(y.renteramount).toFixed(2) }}</span>
                                                                </td>
                                                                <td><span>{{ Number(y.renteramounttax).toFixed(2)
                                                                        }}</span></td>
                                                                <td><span>{{ (Number(y.renteramounttax) +
                                                                    Number(y.renteramount)).toFixed(2) }}</span>
                                                                </td>
                                                                <td><span>{{ Number(y.dueamount -
                                                                        y.totalamount).toFixed(2)
                                                                        }}</span></td>
                                                                <td>{{ y.totalamount }}</td>
                                                            </tr>
                                                            <tr v-for="(y, id) in commission" :key="y">
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                    {{ id + 1 + this.allinstallment.length }}
                                                                </td>
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                      <a @click.prevent="removecom(id)">{{ $t(y.name)
                                                                        }}</a>
                                                                </td>
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                    عن الفترة من تاريخ {{ y.duedate }}
                                                                </td>
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                    {{ y.comamount }}
                                                                </td>
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                    {{ ((y.comamount * y.tax) / 100).toFixed(2) }}
                                                                </td>
                                                                <td></td>
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                    <span v-if="y.paied > 0">{{
                                                                        Number(y.paied).toFixed(2)
                                                                        }}</span>
                                                                </td>
                                                                <td v-if="Number(y.amount - y.paied).toFixed(2) != 0">
                                                                    {{ Number(y.amount - y.paied).toFixed(2) }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colspan="2">{{ $t("total") }}</td>
                                                                <td colspan="4">{{ textamount }}</td>
                                                                <td>{{ totaldue }}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                    <br />
                                                    وهذا الخطاب بالمبلغ المستحق عليكم لذا نأمل سرعة
                                                    السداد وإصدار شيك باسم /
                                                    {{ this.$store.state.cnum[0].cname }}
                                                    العقاري او الايداع فى احد حساباتنا رقم : <br />
                                                    SA0980000101608013332224 مصرف الراجحى <br />
                                                    SA1305000068201333222000 مصرف الانماء <br />
                                                    SA7215000427122878050001 بنك البلاد <br /><br />
                                                    مستخدم : {{ loginUser }}<br />
                                                    تاريخ الطباعة: {{ currentDate }}<br />
                                                    ولكم جزيل الشكر ,,,,,
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                                    {{ $t("cancel") }}
                                                </button>
                                                <button type="button" class="btn btn-primary" @click="pdf">
                                                    <i class="bi bi-printer-fill"></i> {{ $t("print") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="buttom">
            <button class="buttonconfirm" type="submit" v-if="this.view != 0" @click="pdf">
                <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
            </button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import vSelect from "vue-select";
import html2pdf from "html2pdf.js";
import store from "@/store";
var tafqeet = require("../../TafqeetJs-master/Tafqeet");
import * as XLSX from "xlsx";
//  import "moment/locale/ar";
export default {
    components: {
        vSelect,
    },
    async mounted() {
        // Fetch properties
        // moment.locale("ar");
        const result2 = await axios.get("/data/getallproperty");
        if (result2.status == 200) {
            const accounts = result2.data.data;
            for (let i = 0; i < accounts.length; i++) {
                this.accounts.push({ name: accounts[i].name, pid: accounts[i].pid });
            }
        }

        // Fetch renters
        const resultRenters = await axios.get("/data/getallrenters");
        if (resultRenters.status == 200) {
            const renters = resultRenters.data.data;
            this.renters = [{ name: "كل المستأجرين", renterid: "all" }];
            for (let i = 0; i < renters.length; i++) {
                this.renters.push({ name: renters[i].rentername, renterid: renters[i].renterid });
            }
        }




        this.url = store.state.imgurl + `/clogo/${this.$store.state.cnum[0].cnum}.png`;
    },
    props: ["css"],
    data() {
        return {
            item: {},
            fromdate: "",
            selectedRenter: null,
            selectedStatus: null,
            renters: [{ name: "كل المستأجرين", renterid: "all" }],
            statuses: [{ name: "كل الحالات", status: "all" }, { name: "فعال", status: "active" }, { name: "منتهى", status: "archive" }],
            todate: "",
            data1: [],
            allinstallment: [],
            view: "",
            namear: "",
            nameen: "",
            typeact: "",
            accounts: [{ name: "كل العقارات", pid: "all" }],
            realty: "",
            totaldue: 0,
            textamount: "",
            commission: [],
            conttype: "",
            id: "",
            rentername: "",
            unite: "",
            propertyname: "",
            igarnumber: "",
            contstart: "",
            comend: "",
            from: "",
            to: "",
            loginUser: store.state.randp.username,
        };
    },
    methods: {
        async submit() {
            if (this.from && this.to) {
                const renterId = this.selectedRenter ? this.selectedRenter.renterid : "all";
                const status = this.selectedStatus ? this.selectedStatus.status : "all";
                const result = await axios.get(
                    `/reports/rentalstatement/${this.from}/${this.to}/${this.item.pid}/${renterId}/${status}`
                );
                if (result.status == 200) {
                    this.data1 = result.data.data;
                    this.realty = this.item.name;
                    this.fromdate = this.from;
                    this.todate = this.to;
                }
            }
        },
        async getallpayments() {
            for (let x = 0; x < this.data1.length; x++) {
                const element = this.data1[x];
                const result = await axios.get(`/reports/getinstallment2/${element.duedate}/${element.duedate}/${element.conid}`);
                if (result.data.data.length == 0) {
                    element.paid = 'تم السداد'
                }
                else {
                    element.paid = result.data.data[0].change * -1
                    element.totalchange = result.data.data[0].totalchange
                }

                const result2 = await axios.get(`/reports/getallcommissions/${element.conid}`);
                const data = result2.data.data
                const amount = data.reduce((acc, array) => acc + Number(array.amount), 0).toFixed(2);
                const paid = data.reduce((acc, array) => acc + Number(array.paied), 0).toFixed(2);
                element.paidcom = Number(amount - paid).toFixed(2);
            }
        },
        async getinstallment(id, from, i, dueamount) {
            const result2 = await axios.get(`/reports/getcontractnumber/${id}/${i.id}`);
            this.igarnumber = result2.data.data[0];
            this.id = result2.data.data[1];
            this.rentername = i.rentername;
            this.unite = i.unite;
            this.propertyname = i.propertyname;
            this.contstart = i.contstart;
            this.comend = moment(this.contstart).add(1, "Y").format("YYYY-MM-DD");
            this.allinstallment = [];
            this.totaldue = 0;
            const result = await axios.get(`/reports/getinstallment/${from}/${from}/${id}`);
            if (result.status == 200) {
                const data = result.data.data;
                this.conttype = data.length > 0?result.data.data[0].conttype:null;
                if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    if (this.conttype == "commercial") {
                        if (Math.abs(data[i].change) > 0) {
                            const amount = Math.abs(data[i].change);
                            this.allinstallment.push({
                                duetype: data[i].duetype,
                                amountwithout: data[i].dueamount,
                                amount: Number(amount / 1.15).toFixed(2),
                                amounttax: Number(((amount / 1.15) * 15) / 100).toFixed(2),
                                from: data[i].duedate,
                                to: moment(data[i].duedate).add(data[0].instdue, "M").format("YYYY-MM-DD"),
                                totalamount: Number(amount).toFixed(2),
                                dueamount: dueamount,
                                renteramount: dueamount / 1.15,
                                renteramounttax: Number(((dueamount / 1.15) * 15) / 100).toFixed(2),
                            });
                        } else {
                            const amount = data[i].dueamount;
                            console.log(data[0].instdue);

                            this.allinstallment.push({
                                duetype: data[i].duetype,
                                amount: Number(amount / 1.15).toFixed(2),
                                amounttax: Number(((amount / 1.15) * 15) / 100).toFixed(2),
                                from: data[i].duedate,
                                to: moment(data[i].duedate).add(data[0].instdue, "M").format("YYYY-MM-DD"),
                                totalamount: Number(amount).toFixed(2),
                                dueamount: dueamount,
                                renteramount: dueamount / 1.15,
                                renteramounttax: Number(((dueamount / 1.15) * 15) / 100).toFixed(2),
                            });
                        }
                    }
                    if (this.conttype == "residential") {
                        if (Math.abs(data[i].change) > 0) {
                            const amount = Math.abs(data[i].change);
                            this.allinstallment.push({
                                duetype: data[i].duetype,
                                amountwithout: data[i].dueamount,
                                amount: Number(amount).toFixed(2),
                                amounttax: 0,
                                from: data[i].duedate,
                                to: moment(data[i].duedate).add(data[0].instdue, "M").format("YYYY-MM-DD"),
                                totalamount: Number(amount).toFixed(2),
                                dueamount: dueamount,
                                renteramount: dueamount,
                                renteramounttax: 0,
                            });
                        } else {
                            const amount = data[i].dueamount;
                            this.allinstallment.push({
                                duetype: data[i].duetype,
                                amount: Number(amount).toFixed(2),
                                amounttax: 0,
                                from: data[i].duedate,
                                to: moment(data[i].duedate).add(data[0].instdue, "M").format("YYYY-MM-DD"),
                                totalamount: Number(amount).toFixed(2),
                                dueamount: dueamount,
                                renteramount: dueamount,
                                renteramounttax: 0,
                            });
                        }
                    }
                }
                }

                const result3 = await axios.get(`/reports/getallcommissions/${id}`);
                if (result3.status == 200) {
                    this.commission = result3.data.data;
                }
                const one = this.allinstallment.reduce((acc, array) => acc + Number(array.totalamount), 0).toFixed(2);
                const two = this.commission.reduce((acc, array) => acc + Number(array.amount), 0).toFixed(2);
                const three = this.commission.reduce((acc, array) => acc + Number(array.paied), 0).toFixed(2);
                this.totaldue = Number(Number(one) + Number(two) - Number(three)).toFixed(2);
                var fraction = this.totaldue.split(".");
                if (fraction.length == 2) {
                    this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " و " + tafqeet.tafqeet(fraction[1]) + " هلله " + " فقط ";
                    if (Number(fraction[1]) == 0) {
                        this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + " فقط ";
                    }
                }
                if (fraction.length == 1) {
                    this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + "فقط";
                }
            }
            const result3 = await axios.get(`/reports/getallcommissions/${id}`);
            if (result3.status == 200) { 
                this.commission = result3.data.data;
            }
        },
        exportToExcel() {
            var data = [];
            for (let i = 0; i < this.data1.length; i++) {
                const name = this.data1[i];
                data.push({
                    رقم_العقد: name.conid,
                    اسم_العقار: name.propertyname,
                    تاريخ_الاستحقاق: name.duedate,
                    تاريخ_بدا_العقد: name.contstart,
                    تاريخ_نهاية_العقد: name.contend,
                    رقم_الوحدة: name.unite,
                    اسم_المستاجر: name.rentername,
                    مبلغ_الاستحقاق: name.dueamount,
                    المتبقى_من_السداد: name.paid,
                    اجمالى_المستحق : name.totalchange,
                    المتبقى_من_العمولات: name.paidcom
                });
            }
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, `statement${this.item.name}.xlsx`);
        },
        pdf() {
            html2pdf(document.getElementById("main").innerHTML, {
                margin: 0.5,
                filename: `استحقاق.pdf`,
                image: { type: "jpeg", quality: 100 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
            });
        },
        removeinstall(id) {

            this.allinstallment.splice(id, 1)
                const one = this.allinstallment.reduce((acc, array) => acc + Number(array.totalamount), 0).toFixed(2);
                const two = this.commission.reduce((acc, array) => acc + Number(array.amount), 0).toFixed(2);
                const three = this.commission.reduce((acc, array) => acc + Number(array.paied), 0).toFixed(2);
                this.totaldue = Number(Number(one) + Number(two) - Number(three)).toFixed(2);
                var fraction = this.totaldue.split(".");
                if (fraction.length == 2) {
                    this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " و " + tafqeet.tafqeet(fraction[1]) + " هلله " + " فقط ";
                    if (Number(fraction[1]) == 0) {
                        this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + " فقط ";
                    }
                }
                if (fraction.length == 1) {
                    this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + "فقط";
                }
        },
        removecom(id) {

            this.commission.splice(id, 1)
                const one = this.allinstallment.reduce((acc, array) => acc + Number(array.totalamount), 0).toFixed(2);
                const two = this.commission.reduce((acc, array) => acc + Number(array.amount), 0).toFixed(2);
                const three = this.commission.reduce((acc, array) => acc + Number(array.paied), 0).toFixed(2);
                this.totaldue = Number(Number(one) + Number(two) - Number(three)).toFixed(2);
                var fraction = this.totaldue.split(".");
                if (fraction.length == 2) {
                    this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " و " + tafqeet.tafqeet(fraction[1]) + " هلله " + " فقط ";
                    if (Number(fraction[1]) == 0) {
                        this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + " فقط ";
                    }
                }
                if (fraction.length == 1) {
                    this.textamount = tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + "فقط";
                }
        }
    },
    watch: {
        item() {
            this.data1 = [];
            this.from = "";
            this.to = "";
        },
        selectedRenter() {
            this.data1 = [];
            this.from = "";
            this.to = "";
        },
        selectedStatus() {
            this.data1 = [];
            this.from = "";
            this.to = "";
        },
    },
    computed: {
        currentDate() {
            return moment().format("DD MMMM YYYY"); // e.g., "10 مايو 2025"
        },
    },
};
</script>
<style lang="scss" scoped>
.page {
    padding: 0.5%;
}

.main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    background-color: #ffffff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.head {
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #dee2e6;
    background-color: #f9fafb;
    border-radius: 8px 8px 0 0;
}

.head1 {
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
    align-items: flex-end;
}

.filter-group {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 200px;
    width: 50%;
}

.renter-group {
    min-width: 300px; // Slightly larger for renters dropdown
}

.filter-group label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0.375rem;
    transition: color 0.2s;
}

.filter-select {
    background-color: #ffffff;
    border: 1px solid #ced4da;
    border-radius: 6px;
    padding: 0.625rem;
    font-size: 0.9rem;
    transition: border-color 0.3s, box-shadow 0.3s, transform 0.2s;
}

.renter-select {
    min-width: 180px; // Ensure renters dropdown is slightly larger
}

.filter-select:focus {
    border-color: #6299ae;
    box-shadow: 0 0 0 4px rgba(98, 153, 174, 0.15);
    outline: none;
    transform: translateY(-1px);
}

.select-option {
    text-align: center;
    padding: 0.625rem;
    color: #2c3e50;
    transition: background-color 0.2s;
}

.select-option:hover {
    background-color: #f1f5f9;
}

.filter-input {
    padding: 0.625rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    font-size: 0.9rem;
    background-color: #ffffff;
    transition: border-color 0.3s, box-shadow 0.3s, transform 0.2s;
}

.filter-input:focus {
    border-color: #6299ae;
    box-shadow: 0 0 0 4px rgba(98, 153, 174, 0.15);
    outline: none;
    transform: translateY(-1px);
}

.filter-button {
    padding: 0.625rem 1.25rem;
    border: none;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.625rem;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s, box-shadow 0.2s;
}

.search-button {
    background-color: #6299ae;
    color: #ffffff;
}

.search-button:hover {
    background-color: #527b8e;
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.excel-button {
    background-color: #28a745;
    color: #ffffff;
}

.excel-button:hover {
    background-color: #218838;
    transform: scale(1.05);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.filter-button i {
    font-size: 1.1rem;
}

.head2 {
    display: flex;
    align-items: flex-end;
}

.table {
    margin-top: 1%;
}

table thead tr {
    border-radius: 5px;
    background-color: #eee;
}

.modhead {
    display: flex;
}

.modhead .part {
    width: 75%;
    //padding-top: 5%;
    font-size: large;
}

.modhead .logo {
    width: 25%;
}

.modhead img {
    width: 100%;
}

@media screen and (max-width: 768px) {
    .head {
        padding: 1rem;
    }

    .head1 {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .filter-group,
    .renter-group {
        min-width: 100%;
    }

    .filter-button {
        width: 100%;
        justify-content: center;
        padding: 0.75rem;
    }

    .head2 {
        width: 100%;
        justify-content: center;
        margin-top: 1.25rem;
    }
}

@media screen and (max-width: 576px) {
    .table {
        width: 90%;
        margin-left: 5%;
        margin-right: 5%;
        background-color: white;
        font-size: xx-small;
    }

    .filter-group label {
        font-size: 0.85rem;
    }

    .filter-select,
    .filter-input {
        font-size: 0.85rem;
        padding: 0.5rem;
    }
}
</style>
